import { Clickable, Col, Icon, Row, Text } from 'components';
import { capitalize, formatLocale, theme } from 'lib';
import mime from 'mime';
import { memo } from 'react';
import { TableComponents } from 'screens/Admin/components';

const ListItem = memo(({ item, onClick = null, dataId }) => {
  const isSelected = dataId === item._id,
    { owner, author, metaData } = item,
    displayUser = author || owner,
    hasMetaData = metaData?.url;

  function getMediaType() {
    if (hasMetaData) return item.metaData.url;
    if (item.processing) return 'Processing...';
    if (item.youtubeId) return 'YouTube video';
    if (!item.media?.length && item.caption?.length) return 'Text';
    if (!item.media?.length) return '';

    const { media } = item,
      firstMedia = media && media[0],
      isVideo =
        mime.getType(firstMedia?.uri)?.includes('video') || firstMedia?.uri.includes('m3u8');

    return isVideo
      ? 'Video'
      : `${media.length > 1 ? `${media.length} i` : 'I'}mage${media.length > 1 ? 's' : ''}`;
  }

  return (
    <TableComponents.Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <TableComponents.Td isSelected={isSelected} first>
        <Text>{displayUser?.name}</Text>
        <Text c1 col={theme.GREY_60}>
          @{displayUser?.username}
        </Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{capitalize(displayUser?.type)}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Clickable onClick={() => hasMetaData && window.open(hasMetaData, '_blank')}>
          <Col noFlex>
            <Text wid="300px" col={hasMetaData && 'blue'} b2={hasMetaData}>
              {getMediaType()}
            </Text>
          </Col>
        </Clickable>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{item.isPost ? 'Post' : 'Your Views on the News'}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} last>
        <Row noFlex>
          <Text>
            {item.createdAt ? formatLocale(new Date(item.createdAt), 'LLL do yyy, hh:mm a') : ''}
          </Text>
          {new Date(item.createdAt) > new Date() && (
            <Icon type="visibleOff" dimensions={20} marg="0 0 0 16px" />
          )}
        </Row>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ListItem;
